import { useState, useEffect } from 'react'
import { getPaymentsAPI } from '../services/payment'

function UsePayments() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getPaymentsAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.payment }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UsePayments
